import { data, useNavigate } from "react-router-dom";
import { LoginFormInterface, FormDataErrorInterface } from "../domain/interfaces/LoginInterface";
import useLoginInfrastructure from "../../Login/infrastructure/hook/useLoginInfrastructure";


const useLogin = () => {
  const { loginState,
    setLoginFormInfrastructure,
    submitLoginInfrastructure,
    setFormDataErrorInfrastructure,
    clearLoginErrorInfrastructure
   } = useLoginInfrastructure();
  const navigate = useNavigate();

  
  const handleSubmit = async () => {
    const { formData } = loginState;
    const { email, password } = formData;
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  
    // --- Inicio de Validaciones ---
    if (!email || !emailRegex.test(email)) {
      setFormDataError({ ...loginState.formDataError, email: true });
      return;
    }
    if (!password) {
      setFormDataError({ ...loginState.formDataError, password: true });
      return;
    }

    await submitLoginInfrastructure();
  };

  const setFormData = (formData: Partial<LoginFormInterface>) => {
    setLoginFormInfrastructure(formData);
  };

  const setFormDataError = (formDataError: Partial<FormDataErrorInterface>) => {
    setFormDataErrorInfrastructure(formDataError);
  };

  const clearLoginError = () => {
    clearLoginErrorInfrastructure();
  };

  return {
    handleSubmit,
    setFormData,
    setFormDataError,
    clearLoginError,
    data: loginState,
  };
};

export default useLogin;